import React from 'react';
import PropTypes from 'prop-types';

import TicketFormFields from 'containers/teacher/Event/Wizzard/Form/SessionTicketsEditor/TicketFormFields';
import FormSection from 'ui/FormSection';

import { DialogContent } from '@mui/material';

const Content = ({ ticket, onChange }) => {
  return (
    <DialogContent dividers>
      <FormSection slim>
        <TicketFormFields
          ticket={ticket}
          onChange={onChange}
          showDelete={false}
        />
      </FormSection>
    </DialogContent>
  );
};

Content.propTypes = {
  ticket: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Content;

